import theme from "@/styles/theme";
import styled from "styled-components";

export const ExpandableDgContainer = styled.div`
  display: flex;
  flex-direction: column;
  .labels-container {
    display: flex;
    flex-direction: row;
    column-gap: 1vw;
    margin-left: auto;
  }
  .label {
    font-family: sans-serif;
    font-size: ${theme.fontSize.mm};
    margin-top: 1vh;
  }
`;
